<template>
  <div class="d-flex m-3 gap-2">
 
    <!-- Main Content -->
    <div class="w-80 d-flex flex-column">
      <div class="card border-0 p-3 shadow-sm w-100">
        <h3 class="mb-2">Status Badge</h3>
        <p class="text-gray-600 mb-2">These badges are used to inform users about the state of a certain content or action.</p>
       
        <h5 class="mt-4 mb-2">How to Import</h5>
        <p class="text-gray-600">To import the StatusBadge component, install its package from bit.dev</p>
        <code class="bg-gray-100 p-3 mt-2">yarn add @bit/dtt.uic.dt-statusbadge</code>
      </div>
 
      <StatusBadgeOverview />
 
      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-4 mt-2">Props</h4>
        <b-table striped bordered :items="arrays" :fields="fields"></b-table>    
      </div>
    </div>
 
 
  </div>
</template>
 
<script>
import StatusBadgeOverview from '@/components/local/StatusBadge/StatusBadgeOverview'
 
export default {
  components: { StatusBadgeOverview },
  data () {
    return {
      components: [
        { name: 'Buttons', link: 'buttons' },
        { name: 'Inputs', link: 'inputs' },
        { name: 'Tabs', link: 'tabs' },
      ],
 
      fields: [
        { key: 'prop', tdClass: 'setAmountTdClass' },
        { key: 'type', tdClass: 'setAmountTdClass' },
        { key: 'default', tdClass: 'setAmountTdClass' },
        { key: 'description' }
      ],
 
      arrays: [
        { prop: 'id', type: 'String', default:'', description: 'The id attribute of the component' },
        { prop: 'variant', type: 'String', default:'secondary', description: 'Applies theme color variants to the component' }
      ]
    }
  },
 
  methods: {
    setAmountTdClass() {
        return 'code-text'
    }
  }
}
</script>
 
<style>
.code-text {
  font-family: "SFMono-Regular", Menlo, Monaco, Consolas, "Liberation Mono" ,"Courier New", monospace;
  color: red!important;
}
</style>